<span *ngIf="prefixText()" class="xp-input__addon xp-input__addon--prefix">{{ prefixText() }}</span>
<input class="xp-input__control"
       [type]="type()"
       [placeholder]="placeholder()"
       [readonly]="readonly()"
       [attr.min]="min()"
       [attr.max]="max()"
       [ngModel]="value()"
       (ngModelChange)="value.set($event)" />
<span *ngIf="suffixText()" class="xp-input__addon">{{ suffixText() }}</span>
